
// src/services/UserService.js

import { callApi } from  'services/ApiCommon';

const REACT_APP_BE_API = process.env.REACT_APP_BE_API;

/*
export const fetchMdlrmdlUserInfo = async (userId) => {
    try {
      const response = await fetch(`${REACT_APP_BE_API}/mdlrmdlUserInfo?사용자ID=${userId}`);
      if (!response.ok) {
        throw new Error('서버 응답이 실패했습니다');
      }
      const data = await response.json();
      return data.mdlrmdlUserInfo;
    } catch (error) {
      console.error('모델러 사용자 정보 조회 중 오류 발생:', error);
      throw error;
    }
  };  
*/

// 아래 save 처럼, 호출하는 쪽에서 직접 callApi 사용하도록 하는게 더 맞지 않을까?
export const fetchMdlrmdlUserInfo = async (userId) => {
  try {
    const response = await callApi('selectMdlrmdlUser', {
      usrid: userId
    });
    return response.mdlrmdlUser;
  } catch (error) {
    console.error('모델러 사용자 정보 조회 중 오류 발생:', error);
    throw error;
  }
};



